module.exports = __webpack_public_path__ + "images/round-plus-white.abc8d33967aba505ba91ec45fa3493b5.svg";